import { Component, input, OnInit } from '@angular/core';

type FormInputType =
  | 'text-input'
  | 'datepicker'
  | 'checkbox'
  | 'dropdown'
  | 'radiobutton'
  | 'classification'
  | 'file-upload';

@Component({
  selector: 'lib-dot-indicator',
  templateUrl: './dotindicator.component.html',
  styleUrls: ['./dotindicator.component.scss'],
  standalone: false,
})
export class DotIndicatorComponent implements OnInit {
  type = input<FormInputType>();
  label = input<string>();
  ariaLabel = input<string>();
  isVisible = input<boolean>();
  tooltip = input<string | undefined>();
  ariaDescription = input<string | undefined>();
  tooltipTriggers = input<string | undefined>('hover-persist');
  tooltipContainerClass = input<string | undefined>('fit-content');
  dotContainerClassName = 'dot-container';

  ngOnInit() {
    this.setDotContainerClassName();
  }

  setDotContainerClassName(): void {
    if (this.type() !== undefined) {
      this.dotContainerClassName = `${this.dotContainerClassName}-${this.type()}`;
    }
  }
}
